// extracted by mini-css-extract-plugin
module.exports = {"root":"search_root__1uU36"};